import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';
import { ContabilidadComponent } from './Contabilidad.component';


import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';



const routes = [
    {
        path     : 'Contabilidad',
        component: ContabilidadComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Contabilidad',
          nombreFormulario : 'Contabilidad'
        } 
    }
];

@NgModule({
    declarations: [
        ContabilidadComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        ContabilidadComponent
    ]
})

export class ContabilidadModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Contabilidad/Contabilidad.module.ts